import { Link } from 'react-router-dom'

interface AdminErrorStateProps {
  message?: string
  showBackButton?: boolean
}

export default function AdminErrorState({
  message = 'Error loading data',
  showBackButton = true
}: AdminErrorStateProps) {
  return (
    <div className="bg-white rounded-lg p-8">
      <p className="text-red-600 text-lg mb-4">{message}</p>
      {showBackButton && (
        <Link to="/admin" className="text-[#A6410A] hover:text-[#894d35]">
          ← Back to Dashboard
        </Link>
      )}
    </div>
  )
}
